import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiUsers, FiTruck, FiCreditCard, FiTrendingUp } from 'react-icons/fi';
import { adminApi } from '../../services/adminApi';

function AdminDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    adminApi.getDashboard()
      .then((res) => {
        if (res.success) {
          setData(res.data);
          setError(null);
        } else setError(res.message || 'Failed to load');
      })
      .catch((err) => setError(err.message || 'Failed to load'))
      .finally(() => setLoading(false));
  }, []);

  const stats = data?.stats ? [
    { label: 'Pending Farmers', value: String(data.stats.pendingFarmers), icon: FiUsers, to: '/admin/farmers', color: 'green' },
    { label: 'Active Suppliers', value: String(data.stats.activeSuppliers), icon: FiTruck, to: '/admin/suppliers', color: 'blue' },
    { label: 'Vouchers Issued', value: String(data.stats.vouchersCount), icon: FiCreditCard, to: '/admin/vouchers', color: 'orange' },
    { label: 'Avg Risk Score', value: data.stats.avgRiskRating, icon: FiTrendingUp, to: '/admin/risk-scores', color: 'purple' },
  ] : [];

  if (loading) {
    return (
      <div className="admin-page">
        <div className="admin-page-header">
          <h1>Platform Overview</h1>
          <p>Loading...</p>
        </div>
        <div className="admin-loading" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="admin-page">
        <div className="admin-page-header">
          <h1>Platform Overview</h1>
          <p className="admin-error">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <h1>Platform Overview</h1>
        <p>Monitor and manage the AGRO-INVEST ecosystem</p>
      </div>
      <div className="admin-stats-grid">
        {stats.map(({ label, value, icon: Icon, to, color }) => (
          <Link key={label} to={to} className={`admin-stat-card admin-stat-${color}`}>
            <div className="admin-stat-icon">
              <Icon />
            </div>
            <div className="admin-stat-content">
              <span className="admin-stat-value">{value}</span>
              <span className="admin-stat-label">{label}</span>
            </div>
          </Link>
        ))}
      </div>
      <div className="admin-dashboard-sections">
        <section className="admin-section-card">
          <h2>Recent Activity</h2>
          <div className="admin-activity-list">
            {data?.recentActivity?.length ? (
              data.recentActivity.map((a, i) => (
                <div key={i} className="admin-activity-item">
                  <span className="admin-activity-dot" />
                  <div>
                    <strong>{a.description}</strong>
                    <span className="admin-activity-meta">{a.meta}</span>
                  </div>
                </div>
              ))
            ) : (
              <p className="admin-empty">No recent activity</p>
            )}
          </div>
        </section>
        <section className="admin-section-card">
          <h2>Quick Actions</h2>
          <div className="admin-quick-actions">
            <Link to="/admin/farmers" className="admin-quick-action">
              Review farmer registrations
            </Link>
            <Link to="/admin/vouchers" className="admin-quick-action">
              Generate new voucher
            </Link>
            <Link to="/admin/financing" className="admin-quick-action">
              Activate financing
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
}

export default AdminDashboard;
